module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_16.f0818bee.pdf";